/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Mode_Long_PressInputs */

const en_timing_sync_mode_long_press = /** @type {(inputs: Timing_Sync_Mode_Long_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Long Press`)
};

const fr_timing_sync_mode_long_press = /** @type {(inputs: Timing_Sync_Mode_Long_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appui long`)
};

const de_timing_sync_mode_long_press = /** @type {(inputs: Timing_Sync_Mode_Long_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langes Drücken`)
};

const it_timing_sync_mode_long_press = /** @type {(inputs: Timing_Sync_Mode_Long_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pressione lunga`)
};

const ru_timing_sync_mode_long_press = /** @type {(inputs: Timing_Sync_Mode_Long_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Длительное нажатие`)
};

const es_timing_sync_mode_long_press = /** @type {(inputs: Timing_Sync_Mode_Long_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsación larga`)
};

const zh_cn2_timing_sync_mode_long_press = /** @type {(inputs: Timing_Sync_Mode_Long_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`长按`)
};

const ja_timing_sync_mode_long_press = /** @type {(inputs: Timing_Sync_Mode_Long_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`長押し`)
};

const hi_timing_sync_mode_long_press = /** @type {(inputs: Timing_Sync_Mode_Long_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`देर तक दबाए रखें`)
};

const pt_pt2_timing_sync_mode_long_press = /** @type {(inputs: Timing_Sync_Mode_Long_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pressione e segure`)
};

/**
* | output |
* | --- |
* | "Long Press" |
*
* @param {Timing_Sync_Mode_Long_PressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_mode_long_press = /** @type {((inputs?: Timing_Sync_Mode_Long_PressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Mode_Long_PressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_mode_long_press(inputs)
	if (locale === "de") return de_timing_sync_mode_long_press(inputs)
	if (locale === "it") return it_timing_sync_mode_long_press(inputs)
	if (locale === "ru") return ru_timing_sync_mode_long_press(inputs)
	if (locale === "es") return es_timing_sync_mode_long_press(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_mode_long_press(inputs)
	if (locale === "ja") return ja_timing_sync_mode_long_press(inputs)
	if (locale === "hi") return hi_timing_sync_mode_long_press(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_mode_long_press(inputs)
	return en_timing_sync_mode_long_press(inputs)
});